import { useState, useEffect } from 'react';
import { settingsStorage } from '../utils/localStorage';
import { 
  applyTheme, 
  adjustFontSize, 
  adjustFontFamily, 
  toggleHighContrast,
  announceToScreenReader,
  initializeAccessibility
} from '../utils/accessibility';

export const useAccessibility = () => {
  const [settings, setSettings] = useState(() => {
    const stored = settingsStorage.get();
    return stored.accessibility;
  });

  useEffect(() => {
    initializeAccessibility({ accessibility: settings });
  }, [settings]);

  const updateAccessibilitySetting = (key, value) => {
    const newSettings = { ...settings, [key]: value };
    setSettings(newSettings);
    
    settingsStorage.update({
      accessibility: newSettings
    });

    switch (key) {
      case 'theme':
        applyTheme(value);
        break;
      case 'fontSize':
        adjustFontSize(value);
        break;
      case 'fontFamily':
        adjustFontFamily(value);
        break;
      case 'highContrast':
        toggleHighContrast(value);
        break;
      default:
        break;
    }
  };

  const announce = (message, priority = 'polite') => {
    announceToScreenReader(message, priority);
  };

  const resetToDefaults = () => {
    const defaultSettings = {
      theme: 'auto',
      fontSize: 'medium',
      fontFamily: 'default',
      highContrast: false,
      reducedMotion: false,
      screenReaderOptimized: false
    };
    
    setSettings(defaultSettings);
    settingsStorage.update({ accessibility: defaultSettings });
    
    applyTheme(defaultSettings.theme);
    adjustFontSize(defaultSettings.fontSize);
    adjustFontFamily(defaultSettings.fontFamily);
    toggleHighContrast(defaultSettings.highContrast);
  };

  return {
    settings,
    updateAccessibilitySetting,
    announce,
    resetToDefaults
  };
};